

























































import { defineComponent } from '@vue/composition-api';
import TinyNoDataIcon from '@tt4b/ttam-assets/src/svgs/tiny-no-data.svg';
import CatalogWordsAddIcon from '@tt4b/ttam-assets/src/svgs/creative/catalog-words-add.svg';

const name = 'ttam-ad-text-catalog-words';
export default defineComponent({
  name,
  components: {
    CatalogWordsAddIcon,
    TinyNoDataIcon,
  },
  props: {
    words: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const addWord = word => {
      emit('add-word', word);
    };
    return {
      name,
      addWord,
    };
  },
});
